import request from '../request'

/**
 * 设计确认相关接口
 */

/**
 * 删除设计确认
 * @param {string|number} id - 设计确认ID
 */
export function deleteDesignAffirm(id) {
    return request({
        url: `/project-service/cosys/design/affirm/del/${id}`,
        method: 'GET'
    })
}

/**
 * 新增设计确认
 * @param {Object} data - 设计确认数据
 */
export function addDesignAffirm(data) {
    return request({
        url: '/project-service/cosys/design/affirm/add',
        method: 'POST',
        data
    })
}

/**
 * 获取设计确认详情
 * @param {string|number} id - 设计确认ID
 */
export function fetchDesignAffirmDetail(id) {
    return request({
        url: `/project-service/cosys/design/affirm/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 导出设计确认单
 * @param {string|number} id - 设计确认ID
 */
export function exportDesignAffirm(id) {
    return request({
        url: `/project-service/cosys/design/affirm/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}

/**
 * 获取设计确认列表
 * @param {Object} params - 查询参数
 */
export function fetchDesignAffirmList(params) {
    return request({
        url: '/project-service/cosys/design/affirm/list',
        method: 'GET',
        params
    })
}

/**
 * 重新发起设计确认审批
 * @param {Object} data - 审批数据
 */
export function resubmitDesignAffirm(data) {
    return request({
        url: '/project-service/cosys/design/affirm/resubmit',
        method: 'POST',
        data
    })
}

/**
 * 修改设计确认
 * @param {Object} data - 设计确认数据
 */
export function updateDesignAffirm(data) {
    return request({
        url: '/project-service/cosys/design/affirm/update',
        method: 'POST',
        data
    })
}

/**
 * /cosys/design/affirm/export/{id}
 * 导出设计确认单
 * @param {string|number} id - 设计计划ID
 */
export function exportAffirmExport(id) {
    return request({
        url: `/project-service/cosys/affirm/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}
